module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agent))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseAgent
    }
  }, [_vm._v("选择代理商")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.school))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.chooseSchool
    }
  }, [_vm._v("选择幼儿园")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "送课原因:"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "-请选择-"
    },
    on: {
      "change": _vm.changeSendLessonReason
    },
    model: {
      value: (_vm.form.SendLessonReason),
      callback: function($$v) {
        _vm.$set(_vm.form, "SendLessonReason", $$v)
      },
      expression: "form.SendLessonReason"
    }
  }, _vm._l((_vm.SendLessonReasons), function(option) {
    return _c('el-option', {
      attrs: {
        "value": option.id,
        "label": option.name
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "配置赠送课时数:"
    }
  }, [_c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.VirtualList.length == 1),
      expression: "form.VirtualList.length==1"
    }],
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.form.VirtualList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "项目"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "-请选择-",
            "size": "small"
          },
          on: {
            "visible-change": _vm.changeProject,
            "change": function($event) {
              _vm.changeValueP(scope.$index)
            }
          },
          model: {
            value: (scope.row.ProBrand),
            callback: function($$v) {
              _vm.$set(scope.row, "ProBrand", $$v)
            },
            expression: "scope.row.ProBrand"
          }
        }, _vm._l((_vm.Projects), function(option) {
          return _c('el-option', {
            attrs: {
              "value": option.id,
              "label": option.name
            }
          })
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "-请选择-",
            "size": "small"
          },
          on: {
            "visible-change": _vm.changeLessonType,
            "change": function($event) {
              _vm.changeValue(scope.$index)
            }
          },
          model: {
            value: (scope.row.ProId),
            callback: function($$v) {
              _vm.$set(scope.row, "ProId", $$v)
            },
            expression: "scope.row.ProId"
          }
        }, _vm._l((scope.row.LessonTypes), function(option) {
          return _c('el-option', {
            attrs: {
              "value": option.id,
              "label": option.name
            }
          })
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "赠送课时",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small",
            "min": scope.row.minNum,
            "max": scope.row.maxNum,
            "step": scope.row.minNum,
            "disabled": _vm.form.SendLessonReason == 6
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.VirtualList.length > 1),
      expression: "form.VirtualList.length>1"
    }],
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.form.VirtualList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "项目"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "-请选择-",
            "size": "small"
          },
          on: {
            "visible-change": _vm.changeProject,
            "change": function($event) {
              _vm.changeValueP(scope.$index)
            }
          },
          model: {
            value: (scope.row.ProBrand),
            callback: function($$v) {
              _vm.$set(scope.row, "ProBrand", $$v)
            },
            expression: "scope.row.ProBrand"
          }
        }, _vm._l((_vm.Projects), function(option) {
          return _c('el-option', {
            attrs: {
              "value": option.id,
              "label": option.name
            }
          })
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "placeholder": "-请选择-",
            "size": "small"
          },
          on: {
            "visible-change": _vm.changeLessonType,
            "change": function($event) {
              _vm.changeValue(scope.$index)
            }
          },
          model: {
            value: (scope.row.ProId),
            callback: function($$v) {
              _vm.$set(scope.row, "ProId", $$v)
            },
            expression: "scope.row.ProId"
          }
        }, _vm._l((scope.row.LessonTypes), function(option) {
          return _c('el-option', {
            attrs: {
              "value": option.id,
              "label": option.name
            }
          })
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "赠送课时",
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small",
            "min": scope.row.minNum,
            "max": scope.row.maxNum,
            "step": scope.row.minNum
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "65px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteRow(scope.$index, _vm.form.VirtualList)
            }
          }
        }, [_vm._v("\n                                删除\n                            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddBtn),
      expression: "showAddBtn"
    }],
    staticClass: "fa fa-plus-square",
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.addOtherLesson
    }
  }, [_vm._v(" 继续添加其他赠课")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowClassNum),
      expression: "isShowClassNum"
    }],
    attrs: {
      "label": "上课班级数:"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": _vm.maxNum
    },
    model: {
      value: (_vm.form.ClassNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "ClassNum", $$v)
      },
      expression: "form.ClassNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.SendLessonReason == 7),
      expression: "form.SendLessonReason==7"
    }],
    attrs: {
      "label": "OA工作流编号:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.OACode),
      callback: function($$v) {
        _vm.$set(_vm.form, "OACode", $$v)
      },
      expression: "form.OACode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细说明赠课原因:"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.SendLessonRemark),
      callback: function($$v) {
        _vm.$set(_vm.form, "SendLessonRemark", $$v)
      },
      expression: "form.SendLessonRemark"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": function($event) {
        _vm.AddDialogVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('chooseDialog', {
    ref: "chooseDialog",
    on: {
      "dialogList": _vm.getDialogList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-111cb138!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/addSendLessonDialog/index.vue
// module id = 1385
// module chunks = 1